module.exports = __webpack_public_path__ + "img/border6.1931be1c.png";